import React from 'react';
import type { FooterMoreSmallProps } from './types';
import {
  isNil,
  isNotNil,
} from '../../../../utils';
import { useOpenDeeplink } from '../../../../hooks/useOpenDeeplink';
import { useLogAnalyticsEvent } from '../../../../hooks/useLogAnalyticsEvent';
import { Flex, PrimaryButton } from '@banhala/ui-kit';

export const FooterMoreSmall = ({ footer, screen }: FooterMoreSmallProps) => {
  const { openDeeplink } = useOpenDeeplink();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  if (isNil(footer)) return null;

  const handleClickViewAllButton = () => {
    const { deeplink } = footer.item;
    if (deeplink === null) {
      return;
    }

    logAnalyticsEvent({
      name: 'CLICK_MORE_SMALL',
      analytics: {
        ...(isNotNil(screen) && { SCREEN: screen }),
        ...footer.logging.analytics,
      },
      ably_only_log: footer.logging.ably_only_log,
    });

    openDeeplink(deeplink);
  };

  return (
    <Flex padding={{ horizontal: 16 }} margin={{ top: footer.item.margin_top }}>
      <PrimaryButton
        color="gray"
        size="medium"
        variant={'fill'}
        outline
        onPress={handleClickViewAllButton}
      >
        {footer.item.title}
      </PrimaryButton>
    </Flex>
  );
};
